import React from "react";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {PlayersStatisticsTableRowSummaryRowViewModel} from "../../../../domain/yard/lineups/players-statistics/tables/rows/summary/players-statistics.table.row.summary-row.view-model";
import classnames from "classnames";
import styles from "../../styles/box-scores-widget.module.scss";

class BoxScoresWidgetRowPrimaryCellsSummaryProps extends BaseProps {
  summary: Array<PlayersStatisticsTableRowSummaryRowViewModel>;
}

export const BoxScoresWidgetRowPrimaryCellsSummary = (({summary}: BoxScoresWidgetRowPrimaryCellsSummaryProps) => {
  return (
    <>
      {
        summary?.map((summaryItem: PlayersStatisticsTableRowSummaryRowViewModel, index: Number) =>
          <div key={index} className={classnames(styles.row_primary_cells_summary, {[styles.table_summary_row]: index === 0})}>
            {
              summaryItem.title
            }
          </div>)
      }
    </>
  )
});
